// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__256R5","clinicsSelect":"TableHeading_clinicsSelect__29gNn"};